import { NgModule } from '@angular/core';

import { DynamicSizeDirective } from './dynamicSize.directive';

@NgModule({
  exports: [DynamicSizeDirective],
  declarations: [DynamicSizeDirective],
})
export class DynamicSizeModule {}
